const { setInitialised } = window.BAO.Carousel.plugins

class CompleteTheSet extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()

    this.listeners.add(
      this.els.trigger.element,
      'click',
      this.addToCart.bind(this),
    )
  }

  setupCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        mode: 'snap',
        slides: {
          perView: 1.2,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.5,
              spacing: 20,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 3.5,
              spacing: 20,
            },
          },
        },
      },
      [setInitialised()],
    )
  }

  async addToCart () {
    const items = []

    this.els.slide.elements.forEach((el) => {
      const variantId = el.dataset.variantId
      const isAvailable = el.dataset.available === 'true'

      if (isAvailable && variantId) {
        items.push({
          id: parseInt(variantId),
          quantity: 1,
        })
      }
    })

    return window.BAO.Cart.addItem(items)
  }
}

if (!customElements.get('complete-the-set')) {
  customElements.define('complete-the-set', CompleteTheSet)
}
